export default "__VITE_ASSET__BrX4Z5Pn__"